import * as React from 'react';
import {styled} from '../../utils';
import {inject, observer} from 'mobx-react';
import {Auth} from '../../models/authModel';
import Avatar from '../../components/Avatar';
import {BaseButton} from '../../components/Button';
import Flex from '../../components/Flex';

const UserFullName = styled('div')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: theme.fontSize.small,
  fontWeight: 700,
  lineHeight: 1.5,
  marginLeft: 8
}));

const LogoutLink = styled(BaseButton)(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: theme.fontSize.small,
  color: theme.color.primary,
  marginLeft: 8,
  padding: 0,
  border: 0
}));

interface WithInjectedProps {
  auth: Auth;
}

@inject('auth')
@observer
export default class UserPanel extends React.Component<{}, {}> {
  public render() {
    const {
      auth: {profile}
    } = this._withInjectedProps;

    const fullName = profile ? profile.fullName : null;
    const avatar = profile ? profile.avatar : null;

    return (
      <Flex align="center" justify="flex-end" style={{height: '100%'}}>
        {avatar ? <Avatar large={true} circle={true} src={avatar} /> : null}
        <Flex align="flex-start" justify="center" direction="column">
          <UserFullName>{fullName}</UserFullName>
          <LogoutLink onClick={this._logout}>Logout</LogoutLink>
        </Flex>
      </Flex>
    );
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  private _logout = () => {
    this._withInjectedProps.auth.logout();
  };
}



// WEBPACK FOOTER //
// ./src/containers/UserPanel/UserPanel.tsx